import moment from 'moment'
import {AVAILABLE_OR_NOT, RESERVATION_TYPE} from '../../CodeMaster'
import {Nullable} from '../../app/TypeHelpers'
import {LotterySetting} from '../facilities/FacilityForReservation'

export const calculateReservationType = (
    targetDate: moment.Moment,
    currentDateTime: moment.Moment,
    lotteryAvailability: AVAILABLE_OR_NOT,
    lotterySetting: LotterySetting,
): Nullable<RESERVATION_TYPE> => {
    if (lotteryAvailability === AVAILABLE_OR_NOT.UNAVAILABLE) {
        return RESERVATION_TYPE.FIRST_COME
    }

    const isPastDate = targetDate.diff(currentDateTime, 'day') < 0
    if (isPastDate) {
        return RESERVATION_TYPE.FIRST_COME
    }

    const {
        facilityReserveLotteryStart: lotteryStartDay,
        facilityReserveLotteryEnd: lotteryEndDay,
        facilityReserveLotteryMonth,
    } = lotterySetting

    if (lotteryStartDay === null || lotteryEndDay === null ||
        facilityReserveLotteryMonth === null) {
        return null
    }

    return calculateLotteryType(
        currentDateTime,
        Number(lotteryStartDay),
        Number(lotteryEndDay),
        facilityReserveLotteryMonth,
        targetDate,
    )
}

const calculateLotteryType = (
    currentDateTime: moment.Moment,
    lotteryStartDay: number,
    lotteryEndDay: number,
    facilityReserveLotteryMonth: number,
    targetDate: moment.Moment,
): Nullable<RESERVATION_TYPE> => {
    const currentDateOfMonth: number = currentDateTime.date()
    const lotteryTargetMonth: moment.Moment =
        currentDateTime.clone()
            .startOf('month')
            .add(facilityReserveLotteryMonth, 'month')

    if (targetDate.isSame(lotteryTargetMonth, 'month')) {
        const isInLotteryPeriod =
            (lotteryStartDay <= currentDateOfMonth) && (currentDateOfMonth <= lotteryEndDay)
        if (isInLotteryPeriod) {
            return RESERVATION_TYPE.LOTTERY
        } else {
            return RESERVATION_TYPE.FIRST_COME
        }
    } else if (targetDate.isBefore(lotteryTargetMonth, 'month')) {
        return RESERVATION_TYPE.FIRST_COME
    }
    return null
}
